import React from 'react'

function AboutUs() {
    return (
        <div className='main_abt'>
            <div className='container'>
                <div className='row text-center mt-3 mb-3'>
                    <div className='col'>
                        <p className='abt_head'>About Us</p>
                        <div className='row'>
                            <div className='col'>
                                <p className='abt_para'>The Vilvattam Service Co-operative Bank LTD No: 337 was established with a vision to provide accessible financial services and credit facilities to the common people through the co-operative sector. Over the years, the bank has grown into a trusted name in the co-operative banking space and has been promoted to a Class One Special Grade Bank.
Our Head Office and Main Branch are located at Kurichikkara, Thrissur - 28, from where we coordinate our expanding operations and serve our valued customers.
</p>
                            </div>
                        </div>
                    </div>

                    {/* <div className='col'>
                        <p className='abt_head'>Our Commitment</p>
                        <div className='row'>
                            <div className='col'>
                                <p className='abt_para'>At Tellicherry cooperative Urban Bank, our mission extends beyond just banking. We are dedicated to empowering our customers with innovative financial solutions tailored to their unique needs. Whether it's nurturing local businesses, supporting agricultural initiatives, or fostering personal financial stability, we are committed to being a trusted partner every step of the way.</p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default AboutUs